module.exports = __webpack_public_path__ + "img/bj21.76b6d441.png";